// Games — a Windows XP Explorer folder (C:\Program Files\Games) full of real, playable classics.
// Every tile is an Internet Archive item; double-click opens it in its own window (Arcade) where
// archive.org's in-browser DOSBox runs the actual game. We host nothing, we emulate nothing —
// the XP window is ours, the machine is theirs. Community ask 2026-09-08: "games for windows xp".
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import { GAMES, GROUPS, thumbOf, pageOf, openGame } from './catalog';
import go from 'assets/windowsIcons/290.png';
import back from 'assets/windowsIcons/back.png';
import forward from 'assets/windowsIcons/forward.png';
import up from 'assets/windowsIcons/up.png';
import search from 'assets/windowsIcons/299(32x32).png';
import folderOpen from 'assets/windowsIcons/337(32x32).png';
import gamesIcon from 'assets/windowsIcons/358(32x32).png';
import windows from 'assets/windowsIcons/windows.png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import pullup from 'assets/windowsIcons/pullup.png';
import computer from 'assets/windowsIcons/676(16x16).png';
import pinballIcon from 'assets/windowsIcons/pinball.png';
import mineIcon from 'assets/minesweeper/mine-icon.png';
import videosIcon from 'assets/windowsIcons/myvideos16.png';
import mediaIcon from 'assets/windowsIcons/846(16x16).png';

const PATH = 'C:\\Program Files\\Games';

const File = [
  { type: 'item', text: 'Play' },
  { type: 'item', text: 'Random game' },
  { type: 'item', text: 'Open on archive.org' },
  { type: 'separator' },
  { type: 'item', text: 'Close' },
];
const viewMenu = view => [
  { type: 'item', text: 'Tiles', symbol: view === 'tiles' ? 'circle' : undefined },
  { type: 'item', text: 'Icons', symbol: view === 'icons' ? 'circle' : undefined },
  { type: 'item', text: 'Details', symbol: view === 'details' ? 'circle' : undefined },
  { type: 'separator' },
  { type: 'item', text: 'Refresh' },
];
const Help = [{ type: 'item', text: 'About Games' }];

function openApp(name) {
  window.dispatchEvent(new CustomEvent('ic:open', { detail: name }));
}

function Games({ onClose, isFocus }) {
  const [selected, setSelected] = useState(null);
  const [view, setView] = useState('tiles');
  const [about, setAbout] = useState(false);
  const [broken, setBroken] = useState({});

  const grouped = useMemo(
    () => GROUPS.map(g => ({ ...g, items: GAMES.filter(x => x.group === g.id) })),
    [],
  );
  const sel = selected ? GAMES.find(g => g.id === selected) : null;

  useEffect(() => {
    if (!isFocus) return undefined;
    function onKey(e) {
      const tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'Enter' && sel) openGame(sel);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isFocus, sel]);

  function random() {
    openGame(GAMES[Math.floor(Math.random() * GAMES.length)]);
  }
  function onClickOptionItem(item) {
    switch (item) {
      case 'Close':
        onClose();
        break;
      case 'Play':
        if (sel) openGame(sel);
        break;
      case 'Random game':
        random();
        break;
      case 'Open on archive.org':
        window.open(sel ? pageOf(sel) : 'https://archive.org/details/softwarelibrary_msdos_games', '_blank', 'noopener');
        break;
      case 'Tiles':
      case 'Icons':
      case 'Details':
        setView(item.toLowerCase());
        break;
      case 'About Games':
        setAbout(a => !a);
        break;
      default:
    }
  }

  const tile = g => (
    <div
      key={g.id}
      className={`gm__tile gm__tile--${view}${selected === g.id ? ' gm__tile--on' : ''}`}
      data-id={g.id}
      onClick={() => setSelected(g.id)}
      onDoubleClick={() => openGame(g)}
      title={`${g.title} (${g.year}) — double-click to play`}
    >
      <div className="gm__thumb">
        {broken[g.id] ? (
          <img src={gamesIcon} alt="" />
        ) : (
          <img src={thumbOf(g)} alt="" loading="lazy" onError={() => setBroken(b => ({ ...b, [g.id]: true }))} />
        )}
      </div>
      <div className="gm__meta">
        <div className="gm__name">{g.title}</div>
        {view === 'tiles' && (
          <>
            <div className="gm__sub">{g.year} · {g.by}</div>
            <div className="gm__sub gm__sub--dim">{g.controls}</div>
          </>
        )}
      </div>
    </div>
  );

  const row = g => (
    <tr
      key={g.id}
      className={selected === g.id ? 'on' : ''}
      onClick={() => setSelected(g.id)}
      onDoubleClick={() => openGame(g)}
    >
      <td className="c-name"><img src={gamesIcon} alt="" />{g.title}</td>
      <td>{g.year}</td>
      <td>{g.by}</td>
      <td className="c-dim">{g.controls}</td>
    </tr>
  );

  return (
    <Div>
      <section className="gm__toolbar">
        <div className="gm__options">
          <WindowDropDowns items={{ File, View: viewMenu(view), Help }} onClickItem={onClickOptionItem} height={21} />
        </div>
        <img className="gm__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="gm__function_bar">
        <div className="gm__function_bar__button--disable"><img className="gm__function_bar__icon" src={back} alt="" /><span className="gm__function_bar__text">Back</span><div className="gm__function_bar__arrow" /></div>
        <div className="gm__function_bar__button--disable"><img className="gm__function_bar__icon" src={forward} alt="" /><div className="gm__function_bar__arrow" /></div>
        <div className="gm__function_bar__button" onClick={() => openApp('My Computer')}><img className="gm__function_bar__icon--normalize" src={up} alt="" /></div>
        <div className="gm__function_bar__separate" />
        <div className="gm__function_bar__button" onClick={random}><img className="gm__function_bar__icon--normalize" src={search} alt="" /><span className="gm__function_bar__text">Random</span></div>
        <div className="gm__function_bar__button"><img className="gm__function_bar__icon--normalize" src={folderOpen} alt="" /><span className="gm__function_bar__text">Folders</span></div>
        <div className="gm__function_bar__separate" />
        <div className="gm__function_bar__button" onClick={() => setView(v => (v === 'tiles' ? 'icons' : v === 'icons' ? 'details' : 'tiles'))}><img className="gm__function_bar__icon--normalize" src={gamesIcon} alt="" /><div className="gm__function_bar__arrow" /></div>
      </section>
      <section className="gm__address_bar">
        <div className="gm__address_bar__title">Address</div>
        <div className="gm__address_bar__content">
          <img src={gamesIcon} alt="" className="gm__address_bar__content__img" />
          <div className="gm__address_bar__content__text">{PATH}</div>
          <img src={dropdown} alt="" className="gm__address_bar__content__img" />
        </div>
        <div className="gm__address_bar__go"><img className="gm__address_bar__go__img" src={go} alt="" /><span>Go</span></div>
      </section>

      <div className="gm__body">
        <aside className="gm__side">
          <div className="gm__panel gm__panel--hi">
            <div className="gm__panel__head"><span>Game Tasks</span><img src={pullup} alt="" /></div>
            <div className="gm__panel__body">
              <div className="gm__link" onClick={() => sel && openGame(sel)}>▶ Play {sel ? sel.title : 'selected game'}</div>
              <div className="gm__link" onClick={random}>🎲 Random game</div>
              <div className="gm__link" onClick={() => window.open(sel ? pageOf(sel) : 'https://archive.org/details/softwarelibrary_msdos_games', '_blank', 'noopener')}>Open on archive.org</div>
            </div>
          </div>
          <div className="gm__panel">
            <div className="gm__panel__head"><span>Other Places</span><img src={pullup} alt="" /></div>
            <div className="gm__panel__body">
              <div className="gm__link" onClick={() => openApp('Pinball')}><img src={pinballIcon} alt="" />3D Pinball</div>
              <div className="gm__link" onClick={() => openApp('Minesweeper')}><img src={mineIcon} alt="" />Minesweeper</div>
              <div className="gm__link" onClick={() => openApp('Windows Media Player')}><img src={mediaIcon} alt="" />Old Movies</div>
              <div className="gm__link" onClick={() => openApp('My Videos')}><img src={videosIcon} alt="" />My Videos</div>
              <div className="gm__link" onClick={() => openApp('My Computer')}><img src={computer} alt="" />My Computer</div>
            </div>
          </div>
          <div className="gm__panel">
            <div className="gm__panel__head"><span>Details</span><img src={pullup} alt="" /></div>
            <div className="gm__panel__body gm__details">
              {sel ? (
                <>
                  <b>{sel.title}</b>
                  <div>{sel.year} · {sel.by}</div>
                  <div className="gm__details__k">controls</div>
                  <div>{sel.controls}</div>
                  <div className="gm__details__q">{sel.blurb}</div>
                  <div className="gm__details__k">double-click to play</div>
                </>
              ) : (
                <>
                  <b>Games</b>
                  <div>File Folder · {GAMES.length} games</div>
                  <div className="gm__details__q">real games, emulated in your browser by the Internet Archive. windows games boot windows 3.1 first — give them 20 seconds, fren.</div>
                </>
              )}
            </div>
          </div>
        </aside>

        <div className="gm__content">
          {view === 'details' ? (
            <table className="gm__table">
              <thead><tr><th>Name</th><th>Year</th><th>Publisher</th><th>Controls</th></tr></thead>
              <tbody>{grouped.map(g => [<tr key={`h-${g.id}`} className="gm__grouprow"><td colSpan={4}>{g.label} ({g.items.length})</td></tr>, ...g.items.map(row)])}</tbody>
            </table>
          ) : (
            grouped.map(g => (
              <div className="gm__group" key={g.id}>
                <div className="gm__group__head"><span>{g.label}</span><em>({g.items.length})</em></div>
                <div className={`gm__grid gm__grid--${view}`}>{g.items.map(tile)}</div>
              </div>
            ))
          )}
        </div>
        {about && (
          <div className="gm__about" onClick={() => setAbout(false)}>
            <div className="gm__about__box">
              <b>Games</b>
              <p>{GAMES.length} classics from the Windows 3.x Entertainment Packs and the MS-DOS shareware era.</p>
              <p>Every game runs on the Internet Archive&apos;s in-browser emulator (DOSBox). Nothing is hosted or emulated here — archive.org runs the machine, this window just gives it a desktop.</p>
              <p>the internet keeps the games. (real)</p>
              <span className="gm__about__ok">OK</span>
            </div>
          </div>
        )}
      </div>
      <footer className="gm__status">
        <div className="gm__status__cell gm__status__cell--grow">{sel ? `${sel.title} · ${sel.year} · double-click to play` : `${GAMES.length} objects`}</div>
        <div className="gm__status__cell">emulated by the Internet Archive</div>
        <div className="gm__status__cell"><img src={computer} alt="" />My Computer</div>
      </footer>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: #ece9d8;
  font-size: 11px;
  .gm__toolbar { position: relative; display: flex; align-items: center; height: 24px; border-bottom: 1px solid rgba(255,255,255,.7); flex-shrink: 0; background: linear-gradient(to right,#edede5 0%,#ede8cd 100%); }
  .gm__options { height: 23px; border-bottom: 1px solid rgba(0,0,0,.15); border-right: 1px solid rgba(0,0,0,.15); padding-left: 2px; flex: 1; }
  .gm__windows-logo { height: 100%; border-left: 1px solid white; border-bottom: 1px solid rgba(0,0,0,.1); }
  .gm__function_bar { height: 36px; display: flex; align-items: center; padding: 1px 3px 0; border-bottom: 1px solid rgba(0,0,0,.1); flex-shrink: 0; background: linear-gradient(to right,#edede5 0%,#ede8cd 100%); }
  .gm__function_bar__button { display: flex; height: 100%; align-items: center; border: 1px solid transparent; border-radius: 3px; cursor: default; padding: 0 2px;
    &:hover { border: 1px solid rgba(0,0,0,.1); box-shadow: inset 0 -1px 1px rgba(0,0,0,.1); } }
  .gm__function_bar__button--disable { filter: grayscale(1); opacity: .7; display: flex; height: 100%; align-items: center; border: 1px solid transparent; }
  .gm__function_bar__text { margin-right: 4px; }
  .gm__function_bar__icon { height: 30px; width: 30px; &--normalize { height: 22px; width: 22px; margin: 0 4px 0 1px; } }
  .gm__function_bar__separate { height: 90%; width: 1px; background: rgba(0,0,0,.2); margin: 0 2px; }
  .gm__function_bar__arrow { height: 100%; display: flex; align-items: center; margin: 0 4px;
    &:before { content: ''; display: block; border-width: 3px 3px 0; border-color: #000 transparent; border-style: solid; } }
  .gm__address_bar { border-top: 1px solid rgba(255,255,255,.7); height: 22px; display: flex; align-items: center; padding: 0 2px 2px; box-shadow: inset 0 -2px 3px -1px #2d2d2d; flex-shrink: 0; background: linear-gradient(to right,#edede5 0%,#ede8cd 100%); }
  .gm__address_bar__title { color: rgba(0,0,0,.5); padding: 5px; }
  .gm__address_bar__content { border: rgba(228,255,122,.6) 1px solid; height: 100%; display: flex; flex: 1; align-items: center; background: #fff; position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { position: absolute; white-space: nowrap; left: 16px; right: 17px; overflow: hidden; } }
  .gm__address_bar__go { display: flex; align-items: center; padding: 0 18px 0 5px; height: 100%; &__img { height: 95%; margin-right: 3px; } }

  .gm__body { flex: 1; display: flex; min-height: 0; position: relative; }
  .gm__side { width: 190px; flex-shrink: 0; background: linear-gradient(to bottom, #7aa000 0%, #b6dc1a 100%); padding: 10px; overflow-y: auto; }
  .gm__panel { background: #f4f9dd; border: 1px solid #d5e88a; border-radius: 3px 3px 0 0; margin-bottom: 10px; }
  .gm__panel__head { display: flex; justify-content: space-between; align-items: center; height: 23px; padding: 0 8px 0 10px; font-weight: 700; color: #3a5000; background: linear-gradient(to right, #fff 0%, #dff28e 100%); border-radius: 3px 3px 0 0; img { width: 16px; } }
  .gm__panel--hi .gm__panel__head { background: linear-gradient(to right, #ccff00 0%, #a3d100 100%); color: #1a2600; }
  .gm__panel__body { padding: 8px 10px; }
  .gm__link { color: #2f4a00; cursor: pointer; padding: 3px 0; display: flex; align-items: center; gap: 6px; img { width: 16px; height: 16px; } &:hover { color: #6a9400; text-decoration: underline; } }
  .gm__details { color: #2f3b00; line-height: 1.4; b { display: block; margin-bottom: 2px; } }
  .gm__details__k { margin-top: 6px; color: #6a8000; font-size: 10px; text-transform: uppercase; letter-spacing: .5px; }
  .gm__details__q { margin-top: 6px; font-style: italic; color: #4c6200; }

  .gm__content { flex: 1; overflow: auto; background: #fff; padding: 8px 12px 20px; }
  .gm__group__head { display: flex; align-items: center; gap: 6px; color: #2f4a00; font-weight: 700; font-size: 12px; margin: 8px 0 6px; padding-bottom: 2px; border-bottom: 1px solid #c4dc60;
    em { font-style: normal; color: #7a9a00; font-weight: 400; } }
  .gm__grid { display: flex; flex-wrap: wrap; gap: 4px 10px; }
  .gm__tile { display: flex; align-items: center; gap: 8px; padding: 4px 6px; border: 1px solid transparent; border-radius: 3px; cursor: default; user-select: none;
    &:hover { background: #f1f7d8; border-color: #dbe9a3; }
    &--on { background: #dff28e !important; border-color: #a3d100 !important; } }
  .gm__tile--tiles { width: 250px; }
  .gm__tile--icons { flex-direction: column; width: 92px; text-align: center; gap: 4px; }
  .gm__thumb { width: 52px; height: 52px; flex-shrink: 0; background: #111; border: 1px solid #5d7a00; display: flex; align-items: center; justify-content: center; overflow: hidden;
    img { width: 100%; height: 100%; object-fit: cover; image-rendering: auto; } }
  .gm__tile--icons .gm__thumb { width: 48px; height: 48px; }
  .gm__meta { min-width: 0; }
  .gm__name { font-weight: 700; color: #000; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .gm__tile--icons .gm__name { white-space: normal; font-weight: 400; line-height: 1.2; }
  .gm__sub { color: #4b5a20; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; &--dim { color: #8a9a5a; font-size: 10px; } }
  .gm__table { border-collapse: collapse; width: 100%; th { text-align: left; font-weight: 400; color: #3a5000; border-bottom: 1px solid #c4dc60; padding: 2px 6px; } td { padding: 2px 6px; white-space: nowrap; } tr.on td { background: #dff28e; } tbody tr:hover td { background: #f1f7d8; }
    .c-name img { width: 16px; height: 16px; vertical-align: -3px; margin-right: 4px; } .c-dim { color: #8a9a5a; } }
  .gm__grouprow td { font-weight: 700; color: #2f4a00; border-bottom: 1px solid #c4dc60; padding-top: 8px; }
  .gm__about { position: absolute; inset: 0; background: rgba(0,0,0,.35); display: flex; align-items: center; justify-content: center; z-index: 3; }
  .gm__about__box { background: #ece9d8; border: 1px solid #0a246a; box-shadow: 4px 4px 0 rgba(0,0,0,.4); padding: 14px 18px; width: 320px; color: #000; p { margin: 6px 0; } }
  .gm__about__ok { display: inline-block; margin-top: 6px; padding: 2px 18px; border: 1px solid #003c74; border-radius: 3px; background: linear-gradient(#fff,#ecebe5); }
  .gm__status { flex-shrink: 0; height: 20px; display: flex; border-top: 1px solid rgba(0,0,0,.2); background: #ece9d8; }
  .gm__status__cell { padding: 0 8px; display: flex; align-items: center; gap: 4px; border-right: 1px solid rgba(0,0,0,.15); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; img { width: 14px; height: 14px; } &--grow { flex: 1; } &:last-child { border-right: 0; } }
  @media (max-width: 800px) {
    .gm__side { display: none; }
    .gm__tile--tiles { width: 100%; }
    .gm__function_bar__text { display: none; }
  }
`;

export default Games;
